var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconReject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24,2C11.85,2,2,11.85,2,24s9.85,22,22,22,22-9.85,22-22S36.15,2,24,2ZM31.824,35.649l-7.78-7.71-8.177,7.911c-2.683,1.66-5.486-1.559-3.521-4.028l7.71-7.78-7.543-7.658c-1.551-1.557-.778-4.354,1.43-4.663h0c.968-.134,1.628.149,2.375.731l7.634,7.601,8.177-7.911c2.683-1.66,5.486,1.56,3.521,4.028l-7.71,7.78,7.911,8.177c1.66,2.683-1.56,5.486-4.028,3.521Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconReject);
export default __webpack_public_path__ + "static/media/icon-reject.81f00b60e8aa3b8a8b52abd2205865f4.svg";
export { ForwardRef as ReactComponent };